import { format } from "date-fns";

/**
 * Applies timezone offset to given date with the offset value
 * @param sourceDate - In epoch timestamp (seconds)
 * @param offset - Offset value ex. 'UTC+04:00'
 *
 * returns `formatted date`
 */
const formatDateWithTimezoneOffset = (
  timestampS,
  timeZoneOffset,
  formatString = "yyyy-MM-dd HH:mm:ss"
) => {
  const m =
    typeof timeZoneOffset === "string"
      ? timeZoneOffset.match(/([+-])(\d{2}):(\d{2})/)
      : null;
  if (!m) {
    const fallback = new Date((parseInt(timestampS) || 0) * 1000);
    return format(fallback, formatString);
  }
  const [, sign, offsetHours, offsetMinutes] = m;
  const totalOffsetInSeconds =
    (parseInt(offsetHours, 10) * 60 * 60 + parseInt(offsetMinutes, 10) * 60) *
    (sign === "-" ? -1 : 1);
  const timestampTZ = parseInt(timestampS) + totalOffsetInSeconds;
  const absoluteDate = new Date(timestampTZ * 1000);
  const weekDay = absoluteDate.getUTCDay();
  const day = absoluteDate.getUTCDate();
  const month = absoluteDate.getUTCMonth();
  const year = absoluteDate.getUTCFullYear();
  const hours = absoluteDate.getUTCHours();
  const minutes = absoluteDate.getUTCMinutes();
  const seconds = absoluteDate.getUTCSeconds();
  const milliseconds = absoluteDate.getUTCMilliseconds();

  const convertedDate = new Date(
    year,
    month,
    day,
    hours,
    minutes,
    seconds,
    milliseconds
  );
  return format(convertedDate, formatString);
};

export { formatDateWithTimezoneOffset };
